import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum ToastType {
  ERROR,
  SUCCESS
}

export interface ToastConfig {
  type: ToastType;
  icon: string;
  text: string;
}

const BARCODE_ERROR_TOAST: ToastConfig = {
  icon: 'close',
  type: ToastType.ERROR,
  text: $localize `Ungültiger Barcode`
};

const BARCODE_SUCCESS_TOAST: ToastConfig = {
  icon: 'done',
  type: ToastType.SUCCESS,
  text: $localize `Artikel hinzugefügt`
};

const RESERVATION_SUCCESS_TOAST: ToastConfig = {
  icon: 'done',
  type: ToastType.SUCCESS,
  text: $localize `Neue Reservierung`
};

@Injectable({providedIn: 'root'})
export class FeedbackService {
  private _feedback = new BehaviorSubject<ToastConfig | null>(null);
  feedback = this._feedback.asObservable();

  showBarcodeSuccess() {
    this._feedback.next(BARCODE_SUCCESS_TOAST);
  }

  showBarcodeError() {
    this._feedback.next(BARCODE_ERROR_TOAST);
  }

  showReservationSuccess() {
    this._feedback.next(RESERVATION_SUCCESS_TOAST);
  }

  clear() {
    this._feedback.next(null);
  }

  private async beep() {
    const DURATION = 300;
    const PAUSE = 100;
    const BEEP_COUNT = 2;

    function delay(time: number) {
      return new Promise(resolve => setTimeout(resolve, time));
    }

    for (let i = 0; i < BEEP_COUNT; i++) {
      const ctx = new window.AudioContext();
      const osc = ctx.createOscillator();
      osc.type = 'sawtooth';
      osc.connect(ctx.destination);

      osc.start();
      await delay(DURATION);
      osc.stop();
      await delay(PAUSE);
    }
  }
}
